import { Link } from 'react-router-dom';

export default function StaticPage({ title }: { title: string }) {
  return (
    <main className="staticPage">
      <Link to="/" data-google-vignette="false">← Home</Link>
      <h1>{title}</h1>
      <p>This page is part of the publishable shell and is ready for production copy before public launch.</p>
    </main>
  );
}
